/* eslint-disable */
// UFA11 V2 — extension dictionary (i18nUfa3): keys added while wiring auth,
// deposit/withdraw, account components. Merged into ./i18n as a side-effect.
import translations from './i18n';
const ext = {
  th: {
    // login.js
    u3_member_id_is:        'รหัสสมาชิกของคุณคือ:',
    u3_hello:               'สวัสดี',
    u3_your_credit:         'ยอดเครดิตของคุณ',
    u3_finance_history:     'ประวัติการเงิน',
    u3_monthly_reward:      'รางวัลประจำเดือน',
    u3_open_card_luck:      'เปิดไพ่เสี่ยงโชค',
    u3_spin_wheel:          'หมุนกงล้อเสี่ยงโชค',
    u3_cashback_credit:     'รับเครดิตเงินคืน',
    u3_contact_staff:       'ติดต่อเจ้าหน้าที่',
    u3_play_entrance_UFA11:'ทางเข้าเล่น UFA11',
    u3_play_entrance_bk1:   'ทางเข้าเล่น ( สำรอง 1)',
    u3_play_entrance_bk2:   'ทางเข้าเล่น ( สำรอง 2)',
    u3_connect_line_login:  'เชื่อมต่อบัญชี LINE LOGIN',
    // deposit.js / withdraw.js
    u3_scan_qr_deposit:     'สเเกน QR ฝากเงิน',
    u3_auto_promotion:      'รับโปรโมชั่นอัตโนมัติ',
    u3_qr_within_5min:      'QR Code ภายใน 5 นาทีเท่านั้น',
    u3_specify_topup_amount:'ระบุจำนวนเงินที่ต้องเติม',
    u3_transfer_min_100:    'โอนเข้าบัญชี * ขั้นต่ำ 100 บาท',
    u3_transfer_to_account: 'โอนเข้าบัญชี',
    u3_wallet_colon:        'วอลเลท',
    // register.js
    u3_register_member:     'สมัครสมาชิก',
    u3_register_intro:      'สมัครสมาชิกเพื่อเข้าเล่นคาสิโนออนไลน์ ที่เว็บไซต์ UFA11.COM',
    u3_set_password:        'ตั้งรหัสผ่าน',
    u3_confirm_password_again:'ยืนยันรหัสผ่านเดิมอีกครั้ง',
    u3_show_password:       'แสดงรหัสผ่าน',
    u3_hide_password:       'ซ่อนรหัสผ่าน',
    u3_name_lastname:       'ชื่อ นามสกุล',
    u3_acc_name_must_match: 'ชื่อบัญชีฝาก ต้องตรงกับบัญชีถอน ต้องภาษาไทยเท่านั้น ไม่เช่นนั้นจะถอนเงินไม่ได้',
    u3_select_bank:         'กรุณาเลือกธนาคาร',
    u3_your_bank_account_no:'เลขบัญชีธนาคารของท่าน',
    u3_line_id_or_phone:    'LINE ID (ถ้าไม่มีใส่เบอร์โทร)',
    u3_refer_channel:       'ไม่ระบุเจอเว็บเราจากช่องทางไหน',
    u3_refer_banner:        'เว็บไซต์ติดแบนเนอร์',
    u3_refer_friend:        'เพื่อนแนะนำ',
    u3_register_note:       'หลังจากท่านสมัครสมาชิกกับเราแล้ว ท่านสามารถเข้าสู่ระบบและฝากเงินได้เอง ผ่านระบบ AUTO โดยท่านไม่ต้องส่งสลิปแจ้งทีมงานเลย ฝากปุ๊บเข้าปั๊บทันที..ระบบอัติโนมัติฝาก-ถอน 30วินาที เท่านั้น!แทงบอลออนไลน์',
    u3_registering:         'กำลังสมัคร...',
    u3_confirm_register:    'ยืนยันสมัคร',
    u3_truewallet:          'ทรูวอลเลท',
    // register validation / notify
    u3_no_bank_account_no:  'คุณยังไม่ได้ใส่เลขบัญชีธนาคาร',
    u3_acc_no_invalid:      'คุณใส่เลขบัญชีไม่ถูกต้อง',
    u3_no_bank_selected:    'คุณยังไม่ได้เลือกธนาคาร',
    u3_enter_truewallet_name:'กรุณาใส่ชื่อบัญชีทรูวอลเลท',
    u3_no_acc_name_found:   'ไม่พบชื่อบัญชี กรุณากรอกชื่อบัญชีเอง',
    u3_acc_no_invalid_check:'เลขบัญชีไม่ถูกต้อง หรือไม่สามารถตรวจสอบบัญชีได้',
    u3_enter_phone_10:      'กรุณาใส่เบอร์โทรศัพท์ให้ครบ 10 หลัก',
    u3_no_name_lastname:    'คุณยังไม่ได้ใส่ชื่อ-นามสกุล',
    u3_please_set_password: 'กรุณาตั้งรหัสผ่าน',
    u3_pass_max15:          'พาสเวิดสูงสุดไม่เกิน 15 ตัว',
    u3_pass_min6:           'พาสเวิดต้องมีอย่างน้อย 6 ตัว',
    u3_pass_mismatch:       'รหัสยืนยันไม่ตรงกัน',
    u3_register_done_wait:  'ทำการสมัครเรียบร้อย กรุณารอสักครู่',
    u3_register_ok_autologin_fail:'สมัครสำเร็จ แต่เข้าสู่ระบบอัตโนมัติไม่สำเร็จ',
    u3_acc_already_registered:'เลขบัญชีนี้ทำการสมัครไปแล้ว',
    u3_phone_already_registered:'เบอร์โทรศัพท์นี้ทำการสมัครไปแล้ว',
    u3_username_or_name_invalid:'Username หรือ ชื่อในการสมัครไม่ถูกต้อง',
    u3_register_fail_retry: 'สมัครไม่สำเร็จ กรุณาลองใหม่อีกครั้ง',
    // coupon.js
    u3_enter_coupon:        'กรอกคูปอง',
    u3_coupon_desc:         'ใส่ Code Coupon ที่ได้รับ เพื่อใช้สิทธิ์โปรโมชั่น',
    u3_coupon_placeholder:  'กรอกรหัสคูปอง',
    u3_confirm_coupon:      'ยืนยันรับคูปอง',
    u3_checking_short:      'กำลังตรวจสอบ...',
    u3_not_logged_in_short: 'คุณไม่ได้ล๊อคอิน',
    u3_error_retry:         'เกิดข้อผิดพลาด กรุณาลองใหม่',
    // checkin.js
    u3_game_not_open:       'เกมยังไม่เปิดให้บริการ',
    // statement.js
    u3_bonus_star:          '*โบนัส',
    // affiliate.js
    u3_easy_rich_with:      'รวยง่ายๆ กับ',
  },
  en: {
    u3_member_id_is:        'Your member ID is:',
    u3_hello:               'Hello',
    u3_your_credit:         'Your credit balance',
    u3_finance_history:     'Transaction History',
    u3_monthly_reward:      'Monthly Reward',
    u3_open_card_luck:      'Open Lucky Card',
    u3_spin_wheel:          'Spin Lucky Wheel',
    u3_cashback_credit:     'Get Cashback Credit',
    u3_contact_staff:       'Contact Staff',
    u3_play_entrance_UFA11:'Play Entrance UFA11',
    u3_play_entrance_bk1:   'Play Entrance (Backup 1)',
    u3_play_entrance_bk2:   'Play Entrance (Backup 2)',
    u3_connect_line_login:  'Connect LINE LOGIN account',
    u3_scan_qr_deposit:     'Scan QR to Deposit',
    u3_auto_promotion:      'Auto promotion',
    u3_qr_within_5min:      'QR Code valid within 5 minutes only',
    u3_specify_topup_amount:'Specify the amount to top up',
    u3_transfer_min_100:    'Transfer to account * minimum 100 baht',
    u3_transfer_to_account: 'Transfer to account',
    u3_wallet_colon:        'Wallet',
    u3_register_member:     'Register',
    u3_register_intro:      'Register to play online casino at UFA11.COM',
    u3_set_password:        'Set password',
    u3_confirm_password_again:'Re-enter password',
    u3_show_password:       'Show password',
    u3_hide_password:       'Hide password',
    u3_name_lastname:       'First name Last name',
    u3_acc_name_must_match: 'The deposit account name must match the withdrawal account and must be in Thai only, otherwise you will not be able to withdraw.',
    u3_select_bank:         'Please select a bank',
    u3_your_bank_account_no:'Your bank account number',
    u3_line_id_or_phone:    'LINE ID (use phone number if none)',
    u3_refer_channel:       'How did you find our website?',
    u3_refer_banner:        'Banner website',
    u3_refer_friend:        'Referred by friend',
    u3_register_note:       'After registering with us, you can log in and deposit by yourself via the AUTO system without sending any slip to staff. Deposit and it credits instantly. Auto deposit-withdraw in only 30 seconds! Online sports betting.',
    u3_registering:         'Registering...',
    u3_confirm_register:    'Confirm Registration',
    u3_truewallet:          'TrueWallet',
    u3_no_bank_account_no:  'You have not entered a bank account number',
    u3_acc_no_invalid:      'You entered an invalid account number',
    u3_no_bank_selected:    'You have not selected a bank',
    u3_enter_truewallet_name:'Please enter the TrueWallet account name',
    u3_no_acc_name_found:   'Account name not found, please enter it yourself',
    u3_acc_no_invalid_check:'Invalid account number or unable to verify the account',
    u3_enter_phone_10:      'Please enter a complete 10-digit phone number',
    u3_no_name_lastname:    'You have not entered your full name',
    u3_please_set_password: 'Please set a password',
    u3_pass_max15:          'Password must be at most 15 characters',
    u3_pass_min6:           'Password must be at least 6 characters',
    u3_pass_mismatch:       'Confirmation password does not match',
    u3_register_done_wait:  'Registration complete, please wait a moment',
    u3_register_ok_autologin_fail:'Registration succeeded but auto login failed',
    u3_acc_already_registered:'This account number has already been registered',
    u3_phone_already_registered:'This phone number has already been registered',
    u3_username_or_name_invalid:'Username or registration name is invalid',
    u3_register_fail_retry: 'Registration failed, please try again',
    u3_enter_coupon:        'Enter Coupon',
    u3_coupon_desc:         'Enter the coupon code you received to use the promotion',
    u3_coupon_placeholder:  'Enter coupon code',
    u3_confirm_coupon:      'Confirm Coupon',
    u3_checking_short:      'Checking...',
    u3_not_logged_in_short: 'You are not logged in',
    u3_error_retry:         'An error occurred, please try again',
    u3_game_not_open:       'The game is not available yet',
    u3_bonus_star:          '*Bonus',
    u3_easy_rich_with:      'Get rich easily with',
  },
  zh: {
    u3_member_id_is:        '您的会员编号是：',
    u3_hello:               '您好',
    u3_your_credit:         '您的余额',
    u3_finance_history:     '财务记录',
    u3_monthly_reward:      '每月奖励',
    u3_open_card_luck:      '开运势卡',
    u3_spin_wheel:          '转幸运转盘',
    u3_cashback_credit:     '领取返现额度',
    u3_contact_staff:       '联系客服',
    u3_play_entrance_UFA11:'游戏入口 UFA11',
    u3_play_entrance_bk1:   '游戏入口（备用 1）',
    u3_play_entrance_bk2:   '游戏入口（备用 2）',
    u3_connect_line_login:  '连接 LINE LOGIN 账户',
    u3_scan_qr_deposit:     '扫码存款',
    u3_auto_promotion:      '自动领取优惠',
    u3_qr_within_5min:      'QR 码仅在 5 分钟内有效',
    u3_specify_topup_amount:'请输入充值金额',
    u3_transfer_min_100:    '转入账户 * 最低 100 泰铢',
    u3_transfer_to_account: '转入账户',
    u3_wallet_colon:        '钱包',
    u3_register_member:     '注册会员',
    u3_register_intro:      '在 UFA11.COM 注册会员畅玩在线娱乐场',
    u3_set_password:        '设置密码',
    u3_confirm_password_again:'再次输入密码',
    u3_show_password:       '显示密码',
    u3_hide_password:       '隐藏密码',
    u3_name_lastname:       '姓名',
    u3_acc_name_must_match: '存款账户姓名必须与提款账户一致，且必须为泰文，否则将无法提款。',
    u3_select_bank:         '请选择银行',
    u3_your_bank_account_no:'您的银行账号',
    u3_line_id_or_phone:    'LINE ID（没有请填电话号码）',
    u3_refer_channel:       '您从哪个渠道找到我们网站？',
    u3_refer_banner:        '横幅广告网站',
    u3_refer_friend:        '朋友推荐',
    u3_register_note:       '注册成为会员后，您可以通过 AUTO 系统自行登录和存款，无需向工作人员发送凭证。存款即时到账，自动存提仅需 30 秒！在线体育投注。',
    u3_registering:         '注册中...',
    u3_confirm_register:    '确认注册',
    u3_truewallet:          'TrueWallet',
    u3_no_bank_account_no:  '您尚未填写银行账号',
    u3_acc_no_invalid:      '您填写的账号不正确',
    u3_no_bank_selected:    '您尚未选择银行',
    u3_enter_truewallet_name:'请填写 TrueWallet 账户姓名',
    u3_no_acc_name_found:   '未找到账户姓名，请自行填写',
    u3_acc_no_invalid_check:'账号不正确或无法验证账户',
    u3_enter_phone_10:      '请填写完整的 10 位电话号码',
    u3_no_name_lastname:    '您尚未填写姓名',
    u3_please_set_password: '请设置密码',
    u3_pass_max15:          '密码最多 15 个字符',
    u3_pass_min6:           '密码至少 6 个字符',
    u3_pass_mismatch:       '确认密码不一致',
    u3_register_done_wait:  '注册完成，请稍候',
    u3_register_ok_autologin_fail:'注册成功，但自动登录失败',
    u3_acc_already_registered:'该账号已被注册',
    u3_phone_already_registered:'该电话号码已被注册',
    u3_username_or_name_invalid:'用户名或注册姓名不正确',
    u3_register_fail_retry: '注册失败，请重试',
    u3_enter_coupon:        '输入优惠券',
    u3_coupon_desc:         '输入收到的优惠券代码以使用优惠',
    u3_coupon_placeholder:  '请输入优惠券代码',
    u3_confirm_coupon:      '确认领取优惠券',
    u3_checking_short:      '检查中...',
    u3_not_logged_in_short: '您尚未登录',
    u3_error_retry:         '发生错误，请重试',
    u3_game_not_open:       '游戏尚未开放',
    u3_bonus_star:          '*奖金',
    u3_easy_rich_with:      '轻松致富，就用',
  },
  ja: {
    u3_member_id_is:        'あなたの会員IDは：',
    u3_hello:               'こんにちは',
    u3_your_credit:         'あなたのクレジット残高',
    u3_finance_history:     '取引履歴',
    u3_monthly_reward:      '月間リワード',
    u3_open_card_luck:      'ラッキーカードを開く',
    u3_spin_wheel:          'ラッキーホイールを回す',
    u3_cashback_credit:     'キャッシュバックを受け取る',
    u3_contact_staff:       'スタッフに連絡',
    u3_play_entrance_UFA11:'プレイ入口 UFA11',
    u3_play_entrance_bk1:   'プレイ入口（予備 1）',
    u3_play_entrance_bk2:   'プレイ入口（予備 2）',
    u3_connect_line_login:  'LINE LOGINアカウントを連携',
    u3_scan_qr_deposit:     'QRをスキャンして入金',
    u3_auto_promotion:      '自動でプロモーション受取',
    u3_qr_within_5min:      'QRコードは5分以内のみ有効',
    u3_specify_topup_amount:'入金額を指定してください',
    u3_transfer_min_100:    '口座へ振込 * 最低100バーツ',
    u3_transfer_to_account: '口座へ振込',
    u3_wallet_colon:        'ウォレット',
    u3_register_member:     '会員登録',
    u3_register_intro:      'UFA11.COMで会員登録してオンラインカジノをプレイ',
    u3_set_password:        'パスワードを設定',
    u3_confirm_password_again:'パスワードを再入力',
    u3_show_password:       'パスワードを表示',
    u3_hide_password:       'パスワードを隠す',
    u3_name_lastname:       '氏名',
    u3_acc_name_must_match: '入金口座名は出金口座と一致し、タイ語のみである必要があります。そうでない場合は出金できません。',
    u3_select_bank:         '銀行を選択してください',
    u3_your_bank_account_no:'あなたの銀行口座番号',
    u3_line_id_or_phone:    'LINE ID（無い場合は電話番号）',
    u3_refer_channel:       'どの経路で当サイトを見つけましたか？',
    u3_refer_banner:        'バナー掲載サイト',
    u3_refer_friend:        '友達の紹介',
    u3_register_note:       '登録後はAUTOシステムでご自身でログイン・入金でき、スタッフへのスリップ送付は不要です。入金即反映、自動入出金はわずか30秒！オンラインスポーツベッティング。',
    u3_registering:         '登録中...',
    u3_confirm_register:    '登録を確定',
    u3_truewallet:          'TrueWallet',
    u3_no_bank_account_no:  '銀行口座番号が未入力です',
    u3_acc_no_invalid:      '口座番号が正しくありません',
    u3_no_bank_selected:    '銀行が未選択です',
    u3_enter_truewallet_name:'TrueWalletの口座名を入力してください',
    u3_no_acc_name_found:   '口座名が見つかりません。ご自身で入力してください',
    u3_acc_no_invalid_check:'口座番号が正しくないか、口座を確認できません',
    u3_enter_phone_10:      '10桁の電話番号を完全に入力してください',
    u3_no_name_lastname:    '氏名が未入力です',
    u3_please_set_password: 'パスワードを設定してください',
    u3_pass_max15:          'パスワードは最大15文字です',
    u3_pass_min6:           'パスワードは最低6文字必要です',
    u3_pass_mismatch:       '確認用パスワードが一致しません',
    u3_register_done_wait:  '登録完了、少々お待ちください',
    u3_register_ok_autologin_fail:'登録は成功しましたが自動ログインに失敗しました',
    u3_acc_already_registered:'この口座番号は既に登録されています',
    u3_phone_already_registered:'この電話番号は既に登録されています',
    u3_username_or_name_invalid:'ユーザー名または登録名が正しくありません',
    u3_register_fail_retry: '登録に失敗しました。もう一度お試しください',
    u3_enter_coupon:        'クーポンを入力',
    u3_coupon_desc:         '受け取ったクーポンコードを入力してプロモーションを利用',
    u3_coupon_placeholder:  'クーポンコードを入力',
    u3_confirm_coupon:      'クーポンを受け取る',
    u3_checking_short:      '確認中...',
    u3_not_logged_in_short: 'ログインしていません',
    u3_error_retry:         'エラーが発生しました。もう一度お試しください',
    u3_game_not_open:       'ゲームはまだ利用できません',
    u3_bonus_star:          '*ボーナス',
    u3_easy_rich_with:      '簡単に稼ごう',
  },
  my: {
    u3_member_id_is:        'သင့်အသင်းဝင် ID မှာ：',
    u3_hello:               'မင်္ဂလာပါ',
    u3_your_credit:         'သင့်ခရက်ဒစ်လက်ကျန်',
    u3_finance_history:     'ငွေကြေးမှတ်တမ်း',
    u3_monthly_reward:      'လစဉ်ဆုလာဘ်',
    u3_open_card_luck:      'ကံစမ်းကတ်ဖွင့်ရန်',
    u3_spin_wheel:          'ကံစမ်းဘီးလှည့်ရန်',
    u3_cashback_credit:     'ငွေပြန်အမ်းခရက်ဒစ်ရယူရန်',
    u3_contact_staff:       'ဝန်ထမ်းကိုဆက်သွယ်ရန်',
    u3_play_entrance_UFA11:'ကစားရန်ဝင်ပေါက် UFA11',
    u3_play_entrance_bk1:   'ကစားရန်ဝင်ပေါက် (အရန် ၁)',
    u3_play_entrance_bk2:   'ကစားရန်ဝင်ပေါက် (အရန် ၂)',
    u3_connect_line_login:  'LINE LOGIN အကောင့်ချိတ်ဆက်ရန်',
    u3_scan_qr_deposit:     'QR စကင်ဖတ်၍ ငွေသွင်းရန်',
    u3_auto_promotion:      'အလိုအလျောက်ပရိုမိုးရှင်းရယူ',
    u3_qr_within_5min:      'QR ကုဒ်သည် ၅ မိနစ်အတွင်းသာသုံးနိုင်သည်',
    u3_specify_topup_amount:'ဖြည့်သွင်းမည့်ပမာဏကိုသတ်မှတ်ပါ',
    u3_transfer_min_100:    'အကောင့်သို့လွှဲရန် * အနည်းဆုံး ၁၀၀ ဘတ်',
    u3_transfer_to_account: 'အကောင့်သို့လွှဲရန်',
    u3_wallet_colon:        'ဝေါ်လက်',
    u3_register_member:     'အသင်းဝင်အကောင့်ဖွင့်ရန်',
    u3_register_intro:      'UFA11.COM တွင် အသင်းဝင်အဖြစ် စာရင်းသွင်းပြီး အွန်လိုင်းကာစီနိုကစားပါ',
    u3_set_password:        'စကားဝှက်သတ်မှတ်ရန်',
    u3_confirm_password_again:'စကားဝှက်ပြန်ထည့်ပါ',
    u3_show_password:       'စကားဝှက်ပြရန်',
    u3_hide_password:       'စကားဝှက်ဖွက်ရန်',
    u3_name_lastname:       'အမည်',
    u3_acc_name_must_match: 'ငွေသွင်းအကောင့်အမည်သည် ငွေထုတ်အကောင့်နှင့်တူရမည်ဖြစ်ပြီး ထိုင်းဘာသာဖြင့်သာဖြစ်ရမည်။ မဟုတ်ပါက ငွေထုတ်၍ရမည်မဟုတ်ပါ။',
    u3_select_bank:         'ဘဏ်ရွေးချယ်ပါ',
    u3_your_bank_account_no:'သင့်ဘဏ်အကောင့်နံပါတ်',
    u3_line_id_or_phone:    'LINE ID (မရှိပါက ဖုန်းနံပါတ်ထည့်ပါ)',
    u3_refer_channel:       'ကျွန်ုပ်တို့ဝဘ်ဆိုဒ်ကို မည်သည့်လမ်းကြောင်းမှတွေ့သနည်း',
    u3_refer_banner:        'ဘန်နာတင်ဝဘ်ဆိုဒ်',
    u3_refer_friend:        'သူငယ်ချင်းအကြံပြုခြင်း',
    u3_register_note:       'ကျွန်ုပ်တို့ထံ စာရင်းသွင်းပြီးနောက် AUTO စနစ်ဖြင့် ကိုယ်တိုင်ဝင်ရောက်ပြီး ငွေသွင်းနိုင်ပါသည်။ ဝန်ထမ်းထံ စလစ်ပို့ရန်မလိုပါ။ ငွေသွင်းသည်နှင့် ချက်ချင်းဝင်သည်။ အလိုအလျောက်ငွေသွင်း-ထုတ် ၃၀ စက္ကန့်သာ! အွန်လိုင်းအားကစားလောင်းကြေး။',
    u3_registering:         'စာရင်းသွင်းနေသည်...',
    u3_confirm_register:    'စာရင်းသွင်းမှုအတည်ပြုရန်',
    u3_truewallet:          'TrueWallet',
    u3_no_bank_account_no:  'ဘဏ်အကောင့်နံပါတ်မထည့်ရသေးပါ',
    u3_acc_no_invalid:      'အကောင့်နံပါတ်မမှန်ကန်ပါ',
    u3_no_bank_selected:    'ဘဏ်မရွေးချယ်ရသေးပါ',
    u3_enter_truewallet_name:'TrueWallet အကောင့်အမည်ထည့်ပါ',
    u3_no_acc_name_found:   'အကောင့်အမည်မတွေ့ပါ၊ ကိုယ်တိုင်ထည့်ပါ',
    u3_acc_no_invalid_check:'အကောင့်နံပါတ်မမှန်ပါ သို့မဟုတ် အကောင့်ကိုစစ်ဆေး၍မရပါ',
    u3_enter_phone_10:      'ဖုန်းနံပါတ် ၁၀ လုံးအပြည့်ထည့်ပါ',
    u3_no_name_lastname:    'အမည်မထည့်ရသေးပါ',
    u3_please_set_password: 'စကားဝှက်သတ်မှတ်ပါ',
    u3_pass_max15:          'စကားဝှက်အများဆုံး ၁၅ လုံးဖြစ်ရမည်',
    u3_pass_min6:           'စကားဝှက်အနည်းဆုံး ၆ လုံးဖြစ်ရမည်',
    u3_pass_mismatch:       'အတည်ပြုစကားဝှက်မကိုက်ညီပါ',
    u3_register_done_wait:  'စာရင်းသွင်းပြီးပါပြီ၊ ခဏစောင့်ပါ',
    u3_register_ok_autologin_fail:'စာရင်းသွင်းအောင်မြင်သော်လည်း အလိုအလျောက်ဝင်ရောက်မှုမအောင်မြင်ပါ',
    u3_acc_already_registered:'ဤအကောင့်နံပါတ်ကို စာရင်းသွင်းပြီးဖြစ်သည်',
    u3_phone_already_registered:'ဤဖုန်းနံပါတ်ကို စာရင်းသွင်းပြီးဖြစ်သည်',
    u3_username_or_name_invalid:'အသုံးပြုသူအမည် သို့မဟုတ် စာရင်းသွင်းအမည်မမှန်ပါ',
    u3_register_fail_retry: 'စာရင်းသွင်းမှုမအောင်မြင်ပါ၊ ထပ်ကြိုးစားပါ',
    u3_enter_coupon:        'ကူပွန်ထည့်ပါ',
    u3_coupon_desc:         'ရရှိသောကူပွန်ကုဒ်ကိုထည့်၍ ပရိုမိုးရှင်းအသုံးပြုပါ',
    u3_coupon_placeholder:  'ကူပွန်ကုဒ်ထည့်ပါ',
    u3_confirm_coupon:      'ကူပွန်အတည်ပြုရယူရန်',
    u3_checking_short:      'စစ်ဆေးနေသည်...',
    u3_not_logged_in_short: 'သင်အကောင့်ဝင်ထားခြင်းမရှိပါ',
    u3_error_retry:         'အမှားဖြစ်ပွားသည်၊ ထပ်ကြိုးစားပါ',
    u3_game_not_open:       'ဂိမ်းကို မဖွင့်ရသေးပါ',
    u3_bonus_star:          '*ဘောနပ်စ်',
    u3_easy_rich_with:      'လွယ်ကူစွာချမ်းသာရန်',
  },
  lo: {
    u3_member_id_is:        'ລະຫັດສະມາຊິກຂອງທ່ານແມ່ນ:',
    u3_hello:               'ສະບາຍດີ',
    u3_your_credit:         'ຍອດເຄຣດິດຂອງທ່ານ',
    u3_finance_history:     'ປະຫວັດການເງິນ',
    u3_monthly_reward:      'ລາງວັນປະຈໍາເດືອນ',
    u3_open_card_luck:      'ເປີດໄພ່ສ່ຽງໂຊກ',
    u3_spin_wheel:          'ໝຸນກົງລໍ້ສ່ຽງໂຊກ',
    u3_cashback_credit:     'ຮັບເຄຣດິດເງິນຄືນ',
    u3_contact_staff:       'ຕິດຕໍ່ພະນັກງານ',
    u3_play_entrance_UFA11:'ທາງເຂົ້າຫຼິ້ນ UFA11',
    u3_play_entrance_bk1:   'ທາງເຂົ້າຫຼິ້ນ (ສຳຮອງ 1)',
    u3_play_entrance_bk2:   'ທາງເຂົ້າຫຼິ້ນ (ສຳຮອງ 2)',
    u3_connect_line_login:  'ເຊື່ອມຕໍ່ບັນຊີ LINE LOGIN',
    u3_scan_qr_deposit:     'ສະແກນ QR ຝາກເງິນ',
    u3_auto_promotion:      'ຮັບໂປຣໂມຊັ່ນອັດຕະໂນມັດ',
    u3_qr_within_5min:      'QR Code ໃຊ້ໄດ້ພາຍໃນ 5 ນາທີເທົ່ານັ້ນ',
    u3_specify_topup_amount:'ລະບຸຈຳນວນເງິນທີ່ຕ້ອງເຕີມ',
    u3_transfer_min_100:    'ໂອນເຂົ້າບັນຊີ * ຂັ້ນຕ່ຳ 100 ບາດ',
    u3_transfer_to_account: 'ໂອນເຂົ້າບັນຊີ',
    u3_wallet_colon:        'ວໍເລັດ',
    u3_register_member:     'ສະໝັກສະມາຊິກ',
    u3_register_intro:      'ສະໝັກສະມາຊິກເພື່ອເຂົ້າຫຼິ້ນຄາສິໂນອອນລາຍ ທີ່ເວັບໄຊ UFA11.COM',
    u3_set_password:        'ຕັ້ງລະຫັດຜ່ານ',
    u3_confirm_password_again:'ຢືນຢັນລະຫັດຜ່ານອີກຄັ້ງ',
    u3_show_password:       'ສະແດງລະຫັດຜ່ານ',
    u3_hide_password:       'ເຊື່ອງລະຫັດຜ່ານ',
    u3_name_lastname:       'ຊື່ ນາມສະກຸນ',
    u3_acc_name_must_match: 'ຊື່ບັນຊີຝາກຕ້ອງກົງກັບບັນຊີຖອນ ແລະຕ້ອງເປັນພາສາໄທເທົ່ານັ້ນ ບໍ່ດັ່ງນັ້ນຈະຖອນເງິນບໍ່ໄດ້',
    u3_select_bank:         'ກະລຸນາເລືອກທະນາຄານ',
    u3_your_bank_account_no:'ເລກບັນຊີທະນາຄານຂອງທ່ານ',
    u3_line_id_or_phone:    'LINE ID (ຖ້າບໍ່ມີໃສ່ເບີໂທ)',
    u3_refer_channel:       'ບໍ່ລະບຸວ່າພົບເວັບເຮົາຈາກຊ່ອງທາງໃດ',
    u3_refer_banner:        'ເວັບໄຊຕິດແບນເນີ',
    u3_refer_friend:        'ໝູ່ແນະນຳ',
    u3_register_note:       'ຫຼັງຈາກທ່ານສະໝັກສະມາຊິກກັບເຮົາແລ້ວ ທ່ານສາມາດເຂົ້າສູ່ລະບົບ ແລະຝາກເງິນໄດ້ເອງ ຜ່ານລະບົບ AUTO ໂດຍບໍ່ຕ້ອງສົ່ງສະລິບແຈ້ງທີມງານ. ຝາກປຸ໊ບເຂົ້າປັ໊ບທັນທີ ລະບົບອັດຕະໂນມັດຝາກ-ຖອນ 30 ວິນາທີເທົ່ານັ້ນ! ແທງບານອອນລາຍ',
    u3_registering:         'ກຳລັງສະໝັກ...',
    u3_confirm_register:    'ຢືນຢັນການສະໝັກ',
    u3_truewallet:          'TrueWallet',
    u3_no_bank_account_no:  'ທ່ານຍັງບໍ່ໄດ້ໃສ່ເລກບັນຊີທະນາຄານ',
    u3_acc_no_invalid:      'ທ່ານໃສ່ເລກບັນຊີບໍ່ຖືກຕ້ອງ',
    u3_no_bank_selected:    'ທ່ານຍັງບໍ່ໄດ້ເລືອກທະນາຄານ',
    u3_enter_truewallet_name:'ກະລຸນາໃສ່ຊື່ບັນຊີ TrueWallet',
    u3_no_acc_name_found:   'ບໍ່ພົບຊື່ບັນຊີ ກະລຸນາໃສ່ຊື່ບັນຊີເອງ',
    u3_acc_no_invalid_check:'ເລກບັນຊີບໍ່ຖືກຕ້ອງ ຫຼືບໍ່ສາມາດກວດສອບບັນຊີໄດ້',
    u3_enter_phone_10:      'ກະລຸນາໃສ່ເບີໂທລະສັບໃຫ້ຄົບ 10 ຫຼັກ',
    u3_no_name_lastname:    'ທ່ານຍັງບໍ່ໄດ້ໃສ່ຊື່-ນາມສະກຸນ',
    u3_please_set_password: 'ກະລຸນາຕັ້ງລະຫັດຜ່ານ',
    u3_pass_max15:          'ລະຫັດຜ່ານສູງສຸດບໍ່ເກີນ 15 ຕົວ',
    u3_pass_min6:           'ລະຫັດຜ່ານຕ້ອງມີຢ່າງໜ້ອຍ 6 ຕົວ',
    u3_pass_mismatch:       'ລະຫັດຢືນຢັນບໍ່ກົງກັນ',
    u3_register_done_wait:  'ສະໝັກສຳເລັດແລ້ວ ກະລຸນາລໍຖ້າ',
    u3_register_ok_autologin_fail:'ສະໝັກສຳເລັດ ແຕ່ເຂົ້າສູ່ລະບົບອັດຕະໂນມັດບໍ່ສຳເລັດ',
    u3_acc_already_registered:'ເລກບັນຊີນີ້ໄດ້ສະໝັກໄປແລ້ວ',
    u3_phone_already_registered:'ເບີໂທລະສັບນີ້ໄດ້ສະໝັກໄປແລ້ວ',
    u3_username_or_name_invalid:'Username ຫຼື ຊື່ໃນການສະໝັກບໍ່ຖືກຕ້ອງ',
    u3_register_fail_retry: 'ສະໝັກບໍ່ສຳເລັດ ກະລຸນາລອງໃໝ່ອີກຄັ້ງ',
    u3_enter_coupon:        'ປ້ອນຄູປອງ',
    u3_coupon_desc:         'ໃສ່ Code Coupon ທີ່ໄດ້ຮັບ ເພື່ອໃຊ້ສິດໂປຣໂມຊັ່ນ',
    u3_coupon_placeholder:  'ໃສ່ລະຫັດຄູປອງ',
    u3_confirm_coupon:      'ຢືນຢັນຮັບຄູປອງ',
    u3_checking_short:      'ກຳລັງກວດສອບ...',
    u3_not_logged_in_short: 'ທ່ານຍັງບໍ່ໄດ້ເຂົ້າສູ່ລະບົບ',
    u3_error_retry:         'ເກີດຂໍ້ຜິດພາດ ກະລຸນາລອງໃໝ່',
    u3_game_not_open:       'ເກມຍັງບໍ່ເປີດໃຫ້ບໍລິການ',
    u3_bonus_star:          '*ໂບນັດ',
    u3_easy_rich_with:      'ລວຍງ່າຍໆ ກັບ',
  },
};
Object.keys(ext).forEach((l) => { translations[l] = Object.assign({}, translations[l], ext[l]); });
export default ext;
